// Metada refuses a save whose version is older than the stored profile with one of these codes.
export const CHECKOUT_PROFILE_VERSION_CONFLICT_CODES = [
  'VERSION_CONFLICT',
  'PROFILE_VERSION_CONFLICT',
] as const;
